import InputControl from '../InputControl/InputControl.vue.js';
import masker from '../../utils/mask/masker.js';
import tokens from '../../utils/mask/tokens.js';

//
var script = {
  name: 'InputPhoneControl',
  components: {
    InputControl: InputControl
  },
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input'
  },
  inject: {
    formItem: {
      default: ''
    }
  },
  props: {
    isMasked: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  data: function () { return ({
    innerValue: '',
    maskPhone: '8 (###) ###-##-##'
  }); },
  computed: {
    defaultString: function defaultString() {
      return this.isMasked ? '8 (' : '';
    }

  },
  watch: {
    value: function value(value$1) {
      if (typeof value$1 === 'string' && value$1 !== this.innerValue) {
        this.normalizeValue(value$1);
      }
    },

    innerValue: function innerValue(value) {
      this.$emit('input', value);
    },

    isMasked: function isMasked() {
      this.normalizeValue(this.innerValue);
    }

  },

  mounted: function mounted() {
    this.normalizeValue(this.value);
  },

  methods: {
    handlerInput: function handlerInput(event) {
      var value = event.target.value;
      var phone = this.isMasked ? this.getValueWithoutExtraChars(value) : value;

      if (!phone.length) {
        this.innerValue = phone;
        this.$refs.inputControl.innerValue = '';
        return event.preventDefault();
      } else if (this.isMasked && phone.length > 11) {
        this.normalizeValue(phone);
        this.$refs.inputControl.innerValue = this.innerValue;
        return event.preventDefault();
      } else if (phone !== value) {
        this.normalizeValue(phone);
        this.$refs.inputControl.innerValue = this.innerValue;
        return event.preventDefault();
      }

      this.normalizeValue(phone);
    },

    getValueWithoutExtraChars: function getValueWithoutExtraChars(value) {
      if (typeof value === 'number') { return String(Math.abs(value)); }
      if (typeof value !== 'string') { throw new Error('Не корректное значение'); }
      return value.replace(/\D/g, '');
    },

    normalizeValue: function normalizeValue(value) {
      if (typeof value !== 'string' && !value.length) { return value; }
      this.innerValue = this.isMasked ? this.masked(value) : value;
    },

    masked: function masked(value) {
      // удаляем все символы кроме чисел
      var phone = this.getValueWithoutExtraChars(value); // если телефон начинается с 7 или 8

      var arrVariants = ['7', '8'];

      for (var item of arrVariants) {
        if (phone.indexOf(item) === 0) {
          var val = phone.slice(item.length);
          return masker(val, this.maskPhone, true, tokens);
        }
      }

      return masker(phone, this.maskPhone, true, tokens);
    },

    handlerFocus: function handlerFocus() {
      if (!this.innerValue && !this.innerValue.length) {
        this.innerValue = this.defaultString;
      }
    },

    handlerBlur: function handlerBlur() {
      if (this.innerValue === this.defaultString) {
        this.innerValue = '';
      }
    },

    handlerClear: function handlerClear() {
      this.innerValue = '';
      this.$emit('clear');
    }

  }
};

export default script;
